import { connect } from 'react-redux';
import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Toast from 'light-toast';
import { createUser, editUser, fetchUserDetails } from '../../store/app/apis';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { setUserDetail, setUserList } from '../../store/app';

function CreateUser({ userList, fetchUserDetails, createUser, editUser, projectList, ...props }) {
  const [anchorEl, setAnchorEl] = useState(props.anchorEl);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    name: '',
    role: 0,
    username: '',
    password: '',
    projects: [],
    projectNames: [],
  });

  const cancelPop = () => {
    setAnchorEl(null);
    props.onClose();
  };

  const handleName = (e) => {
    setState((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handlePasswordChange = (e) => {
    setState((prev) => ({
      ...prev,
      password: e.target.value,
    }));
  };

  const handleUserNAmeChange = (e) => {
    setState((prev) => ({
      ...prev,
      username: e.target.value,
    }));
  };

  const handleRoleChange = (e) => {
    setState((prev) => ({
      ...prev,
      role: e.target.value,
    }));
  };

  const handleProjectChange = (value) => {
    var arr2 = [];
    var arr = [];
    for (var i = 0; i < value.length; i++) {
      arr.push(value[i].id);
      arr2.push(value[i].title);
    }
    setState((prev) => ({
      ...prev,
      projects: arr,
      projectNames: arr2,
    }));
  };

  const getProjects = (values) => {
    let temp = [];
    for (const id in values) {
      for (const key in projectList) {
        if (projectList[key].id === values[id]) {
          temp.push(projectList[key]);
        }
      }
    }
    return temp;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if ((state?.name === '', state?.password === '', state?.username === '')) {
      Toast.fail('Please enter all details!');
      return;
    }

    let payload = {
      name: state?.name,
      role: state?.role,
      username: state?.username,
      password: state?.password,
      projects: state?.projects,
      projectNames: state?.projectNames,
    };

    if (props.id) {
      payload.id = props.id;
      editUser(payload).then((res) => cancelPop());
      return;
    }
    createUser(payload).then((res) => cancelPop());
  };
  useEffect(() => {
    setAnchorEl(props.anchorEl);
  }, [props.anchorEl]);

  useEffect(() => {
    if (!props.id) return;
    if (userList?.length !== 0) setState(userList?.find((user) => user.id === props.id));
    else {
      fetchUserDetails(props.id).then((res) => {
        setState(res);
      });
    }
  }, [props.id]);
  return (
    <>
      <Dialog id="popover" open={open} onClose={cancelPop}>
        <Box
          sx={{
            padding: '20px',
          }}
        >
          <div className="form">
            <CloseIcon onClick={cancelPop} sx={{ cursor: 'pointer', float: 'right' }} />
            <h3>User Form </h3>
          </div>

          <form>
            <div className="forminput">
              <label>Enter Name</label>
              <span className="redstar">*</span>
              <TextField
                id="outlined-basic"
                placeholder="Name"
                variant="outlined"
                onChange={handleName}
                value={state?.name}
              />
            </div>
            <div className="forminput">
              <FormControl sx={{ display: 'flex', minWidth: 140, backgroundColor: 'white' }} size="small">
                Role
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={handleRoleChange}
                  value={state?.role ?? ''}
                >
                  <MenuItem value={1}>Admin</MenuItem>
                  <MenuItem value={2}>User</MenuItem>
                </Select>
              </FormControl>
            </div>
            {!props.id && (
              <div className="forminput">
                <label>Username</label>
                <TextField
                  placeholder="username"
                  variant="outlined"
                  onChange={handleUserNAmeChange}
                  value={state?.username}
                />
              </div>
            )}
            <div className="forminput">
              <label>Projects</label>
              <Stack spacing={3} sx={{ width: 500 }}>
                <Autocomplete
                  // sx={muistyles}
                  multiple
                  id="tags-outlined"
                  onChange={(e, value) => {
                    handleProjectChange(value);
                  }}
                  options={projectList}
                  getOptionLabel={(option) => option?.title}
                  value={getProjects(state?.projects)}
                  Select
                  renderInput={(projects) => (
                    <TextField {...projects} label="Select Projects" placeholder="Select Projects" />
                  )}
                />
              </Stack>
            </div>
            {!props.id && (
              <div className="forminput">
                <label>Password</label>
                <TextField
                  id="outlined-basic"
                  placeholder="Password"
                  variant="outlined"
                  onChange={handlePasswordChange}
                  value={state?.password}
                />
              </div>
            )}
            <div className="buttonscancel">
              <button onClick={cancelPop}>Cancel</button>
              <button onClick={handleSubmit}>{props.id ? 'Edit' : 'Add'}</button>
            </div>
          </form>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  projectList: state.app.projectList,
  userDetail: state.app.userDetail,
  userList: state.app.userList,
});

const mapDispatchToProps = { setUserDetail, setUserList, fetchUserDetails, createUser, editUser };

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
